<table>
  <thead>
  <tr>
    <th>Member ID</th>
    <th>Date</th>
    <th>Change Type</th>
    <th>Result</th>
    <th>Transaction ID</th>
    <th>UserID</th>
  </tr>
  </thead>
  <tbody>
  @if (transactions().length) {
    @for (transaction of transactions(); track $index) {
    <tr>
      <td>
        @if (transaction.transactionStatus.toUpperCase() === 'SUCCESS') {
          <a (click)="selectedTransaction.emit(transaction)">{{transaction.memberId || ''}}</a>
        } @else {
          {{transaction.memberId || ''}}
        }
      </td>
      <td>{{transaction.transactionTime | date: 'MM/dd/yyyy HH:mm'}}</td>
      <td>{{transaction.transactionType}}</td>
      <td>{{transaction.transactionStatus | uppercase}}</td>
      <td>{{transaction.transactionId}}</td>
      <td>{{transaction.userName}}</td>
    </tr>
    }
  } @else {
    <tr>
      <td colspan="6" class="no-results"><span>No Transactions Found</span></td>
    </tr>
  }
  </tbody>
</table>

